import { request } from './request';

/**
 * 获取底部联系方式及其外部链接
 */
export function getFooterInfo() {
  return request.get('/comm/footerInfo');
}
